import { render, staticRenderFns } from "./EditPurchasesOrderPage.vue?vue&type=template&id=32bde5c8"
import script from "./EditPurchasesOrderPage.vue?vue&type=script&lang=js"
export * from "./EditPurchasesOrderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports